'use strict';

module.exports = function (page, popstate) {
    setTimeout(function () {
        document.body.classList.remove('is-changing');
        history.back();
    }, 100);
};


//////////////////
// WEBPACK FOOTER
// /home/giant/builds/t1_QpaSbS/0/kpmg/plan-k.cz/node_modules/swup/lib/modules/goBack.js
// module id = 39
// module chunks = 3